import type { ApiContextProps } from '../Contexts/ApiContext';
import type { LocalStorageContextProps } from '../Contexts/LocalStorageContext';
import type { ModeContextProps } from '../Contexts/ModeContext';
import type { SystemContextProps } from '../Contexts/SystemContext';
import type { TokenContextProps } from '../Contexts/TokenContext';
import type { UserContextProps } from '../Contexts/UserContext';
import Mode from '../Enums/Mode';
import TokenType from '../Enums/TokenType';

export function handleDisconnect(apiContext: ApiContextProps, modeContext: ModeContextProps, localStorageContext: LocalStorageContextProps, userContext: UserContextProps, tokenContext: TokenContextProps, systemContext: SystemContextProps): void {

    if (tokenContext.tokenType === TokenType.KFLEET) {
        void apiContext.api?.logout(tokenContext.token); //invalidates the refresh token, but no disaster if this is not done due to being offline
    }
    
    userContext.setCurrentUser(null);
    localStorageContext.localStorageService.clearCurrentUser();
    userContext.setLastActivity(null);
    localStorageContext.localStorageService.clearLastActivity();

    tokenContext.setToken(null);
    tokenContext.setRefreshToken(null);
    tokenContext.setExpiration(null);
    tokenContext.setTokenType(TokenType.TENANT);
    localStorageContext.localStorageService.clearToken();
    localStorageContext.localStorageService.clearRefreshToken();
    localStorageContext.localStorageService.clearExpiration();
    localStorageContext.localStorageService.clearTokenType();

    apiContext.setApi(null);
    localStorageContext.localStorageService.setApiBaseUrl(null);

    modeContext.setMode(Mode.CONNECT);
    localStorageContext.localStorageService.setMode(Mode.CONNECT);

    systemContext.setSystemName(null);
    systemContext.setApiVersion(null);
    systemContext.setIsOffice(false);
    systemContext.setMinAppVersion(null);
    systemContext.setAppEnabled(false);
    systemContext.setLogoUrl(null);
    systemContext.setServerTimezoneOffsetMinutes(null);
    systemContext.setTenantDisplayName(null);
    localStorageContext.localStorageService.clearTenantDisplayName();
}